import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed4ee590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "browser-details" }
const _hoisted_2 = { class: "high-light" }

import { Browser, BrowserInfoDetailKV, BrowserTypesOfSearch, BrowserFilter } from '@/store/modules/browser/types';
import { BrowserGetters, BrowserActions } from '@/store/modules/browser';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';

import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "BrowserSearchList",
});


interface highlight {
    normal: string,
    light: string,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    searchTaskId: {
        type: String,
        required: true,
    },
    searchTarget: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;



const route = useRoute();
const store = useStore();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const browserTypeList = ref<BrowserFilter[]>([])

const searchTypeList = computed(() => {
    let data: BrowserTypesOfSearch[] = store.getters[`browser/${BrowserGetters.getSearchTypes}`](`${props.searchTaskId}_${props.searchTarget}`)
    getFilter(data)
    return data
});
const isDetailsLoading = computed(() => {
    return store.getters[`browser/${BrowserGetters.getDetailsLoading}`]
});
const getIsSearchDetailsLoading = (row: BrowserTypesOfSearch): Browser[] => {
    const target = props.searchTarget
    const browserType = row.browserType;
    const browserUser = row.browserUser;
    const infoType = row.infoType;
    let type = `${target}_${browserType}_${browserUser}_${infoType}`
    return store.getters[`browser/${BrowserGetters.getIsSearchDetailsLoading}`](type);
}

const asyncGetSearchDetailList = (row: BrowserTypesOfSearch): Browser[] => {
    const target = props.searchTarget
    const browserType = row.browserType;
    const browserUser = row.browserUser;
    const infoType = row.infoType;
    const taskId = props.searchTaskId
    let type = `${taskId}_${target}_${browserType}_${browserUser}_${infoType}`
    return store.getters[`browser/${BrowserGetters.getSearchDetails}`](type);
}

const getLabelList = (info: BrowserInfoDetailKV[]): string[] => {
    let labelList: string[] = [];
    for (let i = 0; i < info.length; i++) {
        labelList.push(info[i].Key);
    }
    return labelList
}

const getDataList = (data: Browser[]): BrowserInfoDetailKV[] => {
    let details = data[0].infoDetails;
    let infoList: BrowserInfoDetailKV[] = [];
    let labelList = getLabelList(details);
    for (let i = 0; i < data.length; i++) {
        let info: BrowserInfoDetailKV = {} as BrowserInfoDetailKV;
        for (let j = 0; j < data[i].infoDetails.length; j++) {
            info = {
                ...info,
                [labelList[j]]: data[i].infoDetails[j].Value,
            }
        }
        infoList.push(info);
    }
    return infoList
}

const filterChange = (value: string, row: any, column: any) => {
    return row[column['property']] === value;
}

const handleRowClick = async (row: BrowserTypesOfSearch) => {
    const projId = projectId.value;
    const uid = targetId.value;
    const target = props.searchTarget
    const browserType = row.browserType;
    const browserUser = row.browserUser;
    const infoType = row.infoType;
    const taskId = props.searchTaskId
    try {
        await store.dispatch(`browser/${BrowserActions.asyncGetSearchDetails}`, { projId, uid, target, browserType, browserUser, infoType, taskId })
    } catch (err) {
        console.log(err)
    }
}

const getFilter = (data: BrowserTypesOfSearch[]) => {
    browserTypeList.value = []
    if (data != null) {
        data.forEach(item => { // 遍历表格的数据数组
            if (browserTypeList.value.length === 0) {
                browserTypeList.value.push({
                    text: item.browserType,
                    value: item.browserType
                })
            } else {
                for (let i = 0; i < browserTypeList.value.length; i++) {
                    if (browserTypeList.value[i].value === item.browserType) {
                        break
                    }
                    if (i === browserTypeList.value.length - 1) {
                        browserTypeList.value.push({
                            text: item.browserType,
                            value: item.browserType
                        })
                    }
                }
            }
        })
    }
}

const FilterChar = (data: string): string => {
    return data.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const highLight = (data: string): highlight[] => {
    const res = []
    if (typeof data === "string") {
        const target: string = FilterChar(props.searchTarget)
        const matchedArr = RegExp(target, 'i').exec(data);
        if (!matchedArr || matchedArr.length === 0) {
            res.push({ normal: data, light: '' })
            return res
        }
        const firstMatchedStr = matchedArr[0];
        const temp = data.split(firstMatchedStr)
        const len = temp.length
        for (let i = 0; i < len - 1; i++) {
            res.push({ normal: temp[i], light: firstMatchedStr })
        }
        res.push({ normal: temp[len - 1], light: '' })
        return res
    } else {
        res.push({ normal: data, light: '' })
        return res
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      class: "searchTypeList",
      data: _unref(searchTypeList),
      stripe: "",
      onRowClick: handleRowClick,
      onExpandChange: handleRowClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx((props) => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              (asyncGetSearchDetailList(props.row).length !== 0)
                ? (_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    class: "searchDetailsList",
                    data: getDataList(asyncGetSearchDetailList(props.row)),
                    stripe: "",
                    "max-height": "300px",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "index",
                        width: "50"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLabelList(asyncGetSearchDetailList(props.row)[0].infoDetails), (item) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: item,
                          prop: item,
                          label: item,
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highLight(scope.row[item]), (i, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, [
                                _createTextVNode(_toDisplayString(i.normal), 1),
                                _createElementVNode("span", _hoisted_2, _toDisplayString(i.light), 1)
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["data"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, getIsSearchDetailsLoading(props.row)]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "browserType",
          label: "浏览器",
          filters: browserTypeList.value,
          "filter-method": filterChange,
          "filter-multiple": false
        }, null, 8, ["filters"]),
        _createVNode(_component_el_table_column, {
          prop: "browserUser",
          label: "用户"
        }),
        _createVNode(_component_el_table_column, {
          prop: "infoType",
          label: "信息类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "count",
          label: "相关数据数量"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ])), [
    [_directive_loading, _unref(isDetailsLoading)]
  ])
}
}

})